<template>
	<div class="parenting">
		<el-form :inline="true" :model="formInline" class="demo-form-inline">
		  <el-form-item >
		  	 <span>缴费状态：</span>
		  	  <el-radio-group v-model="formInline.payStatus">
			    <el-radio label="">全部</el-radio>
			    <el-radio :label="0">未缴费</el-radio>
			    <el-radio :label="1">已缴费</el-radio>
            <el-radio :label="2">线下缴费</el-radio>
			  </el-radio-group>
		  </el-form-item>
		  <el-form-item>
		    <el-button type="primary" @click="onSubmit" round>查询</el-button>
		  </el-form-item>
		</el-form>

		<div class="clear">
			<el-button type="primary" @click="add" round class="bb" v-if="matchInfo.matchStatus==1">增加亲子组</el-button>
			<el-button type="primary" @click="onlinePayment" round class="bb" v-if="nowDate<(matchInfo.signEndTime+24*60*60*1000)">线上缴费</el-button>
			<a
				:href="'/marlin/sign/data/sign/parental/export?matchCode='+matchInfo.matchCode"
				class="el-button el-button--primary bb"
				style="border-radius:20px"
				v-if="tableData3.length!=''">导出报名表</a>
				<span style="float: right;line-height: 50px;">共{{person}}组</span>
		</div>

		<div class="tablelist">
			<el-table
			    ref="multipleTable"
			    :data="tableData3"
			    border
			    tooltip-effect="dark"
			    style="width: 100%"
			     @cell-mouse-enter="cellMouseEnter"
				@cell-mouse-leave="cellMouseLeave"
			    @selection-change="handleSelectionChange">
			    <el-table-column
			      type="selection"
			      width="55"
			      :selectable="selectable"
			      align="center">
			    </el-table-column>
			    <el-table-column
			      label="亲子组名称"
			      align="center">
				      <template slot-scope="scope">
				   		<p v-if="(scope.row.payStatus)==0"
				          @click="handleEdit(scope.$index, scope.row)"
				          style="cursor: pointer;color:#44c1de">
				   			{{scope.row.parentalTeamName}}
				   		</p>
				   		<p v-else>{{scope.row.parentalTeamName}}</p>
			   		  </template>
			    </el-table-column>
			    <el-table-column
			      label="孩子"
			      align="center"
			      width="250">
			      <template slot-scope="scope">
			      	<p>姓名：{{scope.row.childrenName}}</p>
			      	<p>身份证：{{scope.row.childrenIdCard}}</p>
			      </template>
			    </el-table-column>
			    <el-table-column
			      label="父亲或母亲"
			      align="center"
			      width="250">
			      <template slot-scope="scope">
			      	<p>姓名：{{scope.row.parentName}}</p>
			      	<p>身份证：{{scope.row.parentIdCard}}</p>
			      </template>
			     </el-table-column>
			     <el-table-column
			      label="金额（人民币）"
			      prop="signPrice"
			      width="120"
			      align="center">
			    </el-table-column>
			    <el-table-column
			      label="缴费状态"
			      width="80"
			      align="center">
			      <template slot-scope="scope">
			      	{{scope.row.payStatus | payToData}}
			      </template>
			    </el-table-column>
			    <el-table-column label="操作"
		   	 	width="80"align="center">
			      <template slot-scope="scope"  v-if="(scope.row.payStatus)==0">
			        <el-button
				          size="mini"
				          type="danger"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-if="scope.row.id==0"
				          ></el-button>
				        <el-button
				          size="mini"
				          type="info"
				          icon="el-icon-delete"
				          @click="handleDelete(scope.$index, scope.row)"
				          v-else
				          ></el-button>
			      </template>
			 </el-table-column>
			 </el-table>

			 <!--报名添加-->
			 <el-dialog title="亲子组报名添加" :visible.sync="dialogFormVisible" width="450px">
				  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
					   <el-form-item label="亲子组名称：" prop="parentalTeamName" style="display: inline-block;">
					     <el-input v-model="ruleForm.parentalTeamName" placeholder="请输入亲子组名称" :maxlength="50" ></el-input>
					  </el-form-item>
					  <el-form-item label="孩子姓名：" prop="childrenName">
					     <el-input v-model="ruleForm.childrenName" placeholder="请输入孩子姓名" :maxlength="20"></el-input>
					  </el-form-item>
					  <el-form-item label="孩子身份证：" prop="childrenIdCard">
					     <el-input v-model="ruleForm.childrenIdCard" placeholder="请输入孩子身份证":maxlength="18"></el-input>
					  </el-form-item>
					  <el-form-item label="父亲或母亲姓名：" prop="parentName">
					     <el-input v-model="ruleForm.parentName" placeholder="请输入父亲或母亲姓名" :maxlength="20"></el-input>
					  </el-form-item>
					  <el-form-item label="父亲或母亲身份证：" prop="parentIdCard">
					     <el-input v-model="ruleForm.parentIdCard" placeholder="请输入父亲或母亲身份证" :maxlength="18"></el-input>
					  </el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer" style="text-align:center">
					    <el-button type="primary" @click="submitForm('ruleForm')" round class="bb">添加</el-button>
					    <el-button @click="dialogFormVisible=false" round style="color:#44C1DE;border: 1px solid #44C1DE;">取消</el-button>
					</div>
				</el-dialog>
				<!--修改-->
				<el-dialog title="亲子组报名修改" :visible.sync="editFormVisible" width="450px">
				  <el-form :model="editForm" :rules="rules" ref="editForm" label-width="150px" class="demo-ruleForm">
					   <el-form-item label="亲子组名称：" prop="parentalTeamName">
					     <el-input v-model="editForm.parentalTeamName" placeholder="请输入亲子组名称名称" :maxlength="50"></el-input>
					  </el-form-item>
					  <el-form-item label="孩子姓名：" prop="childrenName">
					     <el-input v-model="editForm.childrenName" placeholder="请输入孩子姓名" :maxlength="20"></el-input>
					  </el-form-item>
					  <el-form-item label="孩子身份证：" prop="childrenIdCard">
					     <el-input v-model="editForm.childrenIdCard" placeholder="请输入孩子身份证":maxlength="18"></el-input>
					  </el-form-item>
					  <el-form-item label="父亲或母亲姓名：" prop="parentName">
					     <el-input v-model="editForm.parentName" placeholder="请输入父亲或母亲姓名" :maxlength="20"></el-input>
					  </el-form-item>
					  <el-form-item label="父亲或母亲身份证：" prop="parentIdCard">
					     <el-input v-model="editForm.parentIdCard" placeholder="请输入父亲或母亲身份证" :maxlength="18"></el-input>
					  </el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer" style="text-align:center">
					    <el-button type="primary" @click="editSubmit('ruleForm')" round class="bb">修改</el-button>
					    <el-button @click="editCancel" round style="color:#44C1DE;border: 1px solid #44C1DE;">取消</el-button>
					</div>
				</el-dialog>
		</div>
    <div style="display: none">{{changeMatchMsg}}</div>
  </div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				clubInfo:JSON.parse(sessionStorage.getItem("clubInfos")),
				matchInfo:JSON.parse(sessionStorage.getItem('matchInfo')),
				person:0,
				formInline:{
					payStatus:null
				},
				tableData3:[],

				ruleForm:{
					parentalTeamName:null,
					childrenName:null,
					childrenIdCard:null,
					parentName:null,
					parentIdCard:null
				},
				editForm:{},
				dialogFormVisible:false,
				editFormVisible:false,
				rules: {
		          parentalTeamName: [
		            { required: true, message: '请输入亲子组名称', trigger: 'blur' },
		          ],
		          childrenName: [
		            { required: true, message: '请输入孩子姓名', trigger: 'blur' }
		          ],
		          childrenIdCard: [
		            { required: true, message: '请输入孩子身份证', trigger: 'blur' }
		          ],
		          parentName: [
		            { required: true, message: '请输入父亲或母亲姓名', trigger: 'blur' }
		          ],
		          parentIdCard:[
		          	{ required: true, message: '请输入父亲或母亲身份证', trigger: 'blur' }
		          ]
		      	},

		      	//缴费
		        multipleSelection:[],
		        signCodeList:[],
            nowDate:null,
            matchCode:''

			}
		},
    computed: {
      changeMatchMsg(){
        if( null==this.$store.state.matchCodeMsg || "" == this.$store.state.matchCodeMsg){
          this.$store.commit("matchCodeChange",this.$route.query.matchCode)
          this.matchCode= this.$route.query.matchCode;
        }else {
          this.matchCode= this.$store.state.matchCodeMsg;
        }
        this.onSubmit();
        this.matchInfoList();
        return this.$store.state.matchCodeMsg
      }
    },
		filters:{
			payToData(val){
        let result = ''
        if(val == 0){
          result = '未缴费'
        }else if(val == 1){
          result = '已缴费'
        }else if(val == 2){
          result = '线下缴费'
        }
        return result
		    }
		},
		mounted(){
      let nowDate=new Date().getTime()
      this.nowDate=nowDate
			this.onSubmit()
      this.matchInfoList()
		},
		methods:{
      matchInfoList(){
        let self=this
        axios.get('/marlin/sign/data/match/query/single/'+this.matchCode)
          .then(function (res) {
            console.log('resresres',res)
            self.matchInfo=res.data.rst[0]
          })
          .catch(function (res) {

          })
      },
			onSubmit(){
				let self=this
				let postData={
					payStatus:self.formInline.payStatus,
					clubCode:self.clubInfo.clubCode,
					matchCode:self.matchCode,
          pageSize:10000
				}
				axios.post('/marlin/sign/data/sign/parental/query/list',postData)
				.then(function(res){
					if(res.data.code==0){
						self.tableData3=res.data.rst
						self.person=res.data.count
					}
				})
				.catch(function(res){

				})
			},
			add(){
				this.dialogFormVisible=true
			},
			submitForm(formName){
				let self = this
				this.$refs[formName].validate((valid) => {
		          if (valid) {
		            var postData={
		            		"clubCode":self.clubInfo.clubCode,//俱乐部编码 必填
                    "matchCode":self.matchCode,//赛事编码 必填
                    "parentalTeamName":self.ruleForm.parentalTeamName,//亲子组团体名称
                    "childrenName":self.ruleForm.childrenName,//孩子名字
                    "childrenIdCard":self.ruleForm.childrenIdCard,//孩子身份证
                    "parentName":self.ruleForm.parentName,//父亲或母亲名字
                    "parentIdCard":self.ruleForm.parentIdCard//父亲或母亲身份证
		            }

		            axios.post('/marlin/sign/data/sign/parental/add',postData)
		            .then(function(res){
		            		if(res.data.code==0){
		            			self.onSubmit()
		            			self.dialogFormVisible=false
		            			self.ruleForm={}
		            			self.$message({
		            				message:'添加成功',
		            				type:'success'
		            			})

		            		}else{
		            			self.$message({
					          message: res.data.msg,
					          type: 'warning'
					        });
		            		}
		            })
		            .catch(function(res){
		            		overdue(res.response,res.response.status,self)
		            })
		          } else {
		            return false;
		          }
		        });
			},
			handleEdit(index,row){
				this.editFormVisible=true
				this.editForm=row
			},
			editSubmit(){
				let self=this
				let postData={
					"signCode":self.editForm.signCode,//报名编码
					"parentalTeamName":self.editForm.parentalTeamName,//亲子组报名
					"childrenName":self.editForm.childrenName,//孩子名字
					"childrenIdCard":self.editForm.childrenIdCard,//孩子身份证
					"parentName":self.editForm.parentName,//父亲或母亲名字
					"parentIdCard":self.editForm.parentIdCard//父亲或母亲身份证

				}
				axios.post('/marlin/sign/data/sign/parental/update/info',postData)
				.then(function(res){
					if(res.data.code==0){
						self.onSubmit()
						self.editFormVisible=false
						self.$message({
							message:'您已修改成功',
							type:'success'
						})
					}else{
						self.$message({
							message:res.data.msg,
							type:'warning'
						})
					}
				})
				.catch(function(res){

				})
			},
			editCancel(){
				this.onSubmit()
				this.editFormVisible=false
			},
			handleDelete(index,row){
				var self=this
		    		this.$confirm('此操作会删除此条记录, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		      }).then(() => {
					axios.get('/marlin/sign/data/sign/parental/delete/'+row.signCode)
					.then(function(res){
						if(res.data.code==0){
							self.$message({
								message:'您已删除成功！',
								type:'success'
							})
							self.onSubmit()
						}else{
							self.$message({
								message:res.data.msg,
								type:'warning'
							})
						}
					})
					.catth(function(res){
						overdue(res.response,res.response.status,self)
					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消删除'
		          });
		        });
			},
			selectable(row,index){
		   		return row.payStatus==0
		    },
			onlinePayment(){
        if(this.nowDate<(this.matchInfo.signEndTime+24*60*60*1000)){
          var self=this
          var postData={
            "matchCode": this.matchInfo.matchCode,//比赛编码 必填
            "payType":4,//支付类型 1-比赛个人报名 2-比赛团队报名 3-比赛联合报名
            "payWay":1,//支付方式 1-支付宝 2-微信
            "signCodeList":this.signCodeList
          }
          if(this.signCodeList.length>0){
            var url='/pay/pay.html?matchCode='+this.matchInfo.matchCode+"&payType="+4+"&payWay="+1+"&signCodeList="+this.signCodeList.toString()
            window.open(url,'_black')
          }else{
            self.$message({
              message:'请至少选择一个亲子组！',
              type:'warning'
            })
          }
        }

			},
			handleSelectionChange(val){
				this.multipleSelection = val;
				var signCodeList=[]
				for(var i=0;i<this.multipleSelection.length;i++){
					signCodeList.push(this.multipleSelection[i].signCode)
				}
				this.signCodeList=signCodeList
			},
			cellMouseEnter(row,column,cell,event){
		   		row.id=0
		   	},
		   	cellMouseLeave(row,column,cell,event){
		   		row.id=1
		   	}
		}
	}
</script>

<style scoped lang="less">
	.parenting{
		.tablelist{
			margin-top: 20px;
		}
		.el-form-item{
			display: inline-block;
      width: 400px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/parenting.vue